module.exports = __webpack_public_path__ + "img/xls.a1518892.svg";